import {Button, CircularProgress} from "@material-ui/core";
import PropTypes from "prop-types";
import {colors} from "../../../../shared/colors";
import {makeStyles} from "@material-ui/core/styles";

const useButtonWithProgressStyles = makeStyles(() => ({
    wrapper: {
        position: 'relative',
    },
    buttonProgress: {
        color: colors.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

const ButtonWithProgress = (props) => {
    const classes = useButtonWithProgressStyles();

    return (
        <div className={classes.wrapper}>
            <Button
                onClick={props.handleClick}
                color="primary"
                disabled={props.disabled || props.loading}
                startIcon={props.startIcon ? props.startIcon : null}
                endIcon={props.endIcon ? props.endIcon : null}
                variant={props.variant}
            >
                {props.text}
            </Button>
            {props.loading ? <CircularProgress size={24} className={classes.buttonProgress}/> : null}
        </div>
    )
}

ButtonWithProgress.propTypes = {
    handleClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    startIcon: PropTypes.element,
    endIcon: PropTypes.element,
    variant: PropTypes.oneOf(["outlined", "contained", "text"])
}

ButtonWithProgress.defaultProps = {
    disabled: false,
    loading: false,
    variant: "contained"
}

export default ButtonWithProgress;